import { Trans, useTranslation } from '@ecomm/i18n'
import { CheckMark, XSolidIcon } from '@ecomm/shared-icons'
//import { toHtmlId } from '@simplisafe/ewok'
import type { ReactNode } from 'react'
import { Abbr247 } from '../A11yHelpers/Abbr247'

// TODO [@simplisafe/ewok@>=4.9.1]: Remove this function when we upgrade ewok to a version that includes toHtmlId
const toHtmlId = (title: string): string => title.replace(/\W/g, '_')

const Feature = ({
  children,
  isIncluded
}: { readonly children: ReactNode; readonly isIncluded: boolean }) => (
  <li className="list-none flex items-center gap-1 leading-tight">
    {isIncluded ? (
      <CheckMark className="text-complementary-green-100 h-5 w-5 shrink-0" />
    ) : (
      <XSolidIcon className="text-complementary-red-100 h-6 w-6 shrink-0" />
    )}
    <Trans components={{ abbr247: <Abbr247>text</Abbr247> }}>{children}</Trans>
  </li>
)

const FeatureList = ({
  children,
  title
}: {
  readonly children: ReactNode
  readonly title: string
}) => {
  const id = toHtmlId(title)
  return (
    <>
      <p className="sr-only" id={id}>
        {title}
      </p>
      <ul className="m-0 p-0 grid gap-2" aria-label={title}>
        {children}
      </ul>
    </>
  )
}

export function ModalFeatures({
  includedFeatures,
  excludedFeatures
}: {
  readonly includedFeatures: ReadonlyArray<string>
  readonly excludedFeatures?: ReadonlyArray<string>
}) {
  const { t } = useTranslation('common')
  return (
    <div className="grid grid-cols-2 gap-2" data-testid="ModalFeatures">
      <FeatureList title={t('microcopy.included')}>
        {includedFeatures.map(feature => (
          <Feature key={feature} isIncluded={true}>
            {feature}
          </Feature>
        ))}
      </FeatureList>
      {excludedFeatures && (
        <FeatureList title={t('microcopy.not-included')}>
          {excludedFeatures.map(feature => (
            <Feature key={feature} isIncluded={false}>
              {feature}
            </Feature>
          ))}
        </FeatureList>
      )}
    </div>
  )
}
